import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: "0" }
const _hoisted_2 = { key: "0" }

import { computed } from "vue";
import { useBookingStore } from "@/features/booking/store";


export default /*@__PURE__*/_defineComponent({
  __name: 'ProvinciaSelector',
  emits: ["select"],
  setup(__props, { emit: __emit }) {

const bookingStore = useBookingStore();

const emit = __emit;

function select(provincia: string): void {
  emit("select", provincia);
}

const province = computed((): Array<{ long: string }> => {
  return bookingStore.Filiali.map((f) => f.Provincia)
    .filter((v, i, s) => s.indexOf(v) === i)
    .map((f) => {
      return { long: f };
    })
    .sort();
});

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_expansion_panel_title = _resolveComponent("v-expansion-panel-title")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_fade_transition = _resolveComponent("v-fade-transition")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    fluid: "",
    class: "scrollable-content"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_expansion_panels, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_expansion_panel, { readonly: "" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_expansion_panel_title, { "expand-icon": "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, { "no-gutters": "" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { cols: "8" }, {
                        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                          _createElementVNode("strong", null, "Provincia ", -1)
                        ]))]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, { cols: "4" })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(province.value, (e, i) => {
            return (_openBlock(), _createBlock(_component_v_expansion_panel, {
              key: i,
              readonly: "",
              onClick: ($event: any) => (select(e.long))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_expansion_panel_title, { "expand-icon": "" }, {
                  default: _withCtx(({}) => [
                    _createVNode(_component_v_row, { "no-gutters": "" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "8" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_fade_transition, { "leave-absolute": "" }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", _hoisted_1, _toDisplayString(e.long), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_v_col, {
                          cols: "4",
                          class: "text--secondary"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_2, _toDisplayString(e.short), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1032, ["onClick"]))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})